<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate (ngSubmit)="save(participantsForm.value)" [formGroup]="participantsForm">
    <div class="ir-modal--title">
      <div class="ir-line--right"></div>
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'plugins.participants.add-participants' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table">
          <tr class="th-plugin-line--header">
            <td class="th-plugin-line--data">
              <span>{{ 'plugins.participants.participant.name' | translate }}</span>
            </td>
            <td class="th-plugin-line--data">
              <span>{{ 'plugins.participants.participant.function' | translate }}</span>
            </td>
          </tr>
          <tr
            class="th-plugin-line--input"
            formArrayName="participants"
            *ngFor="let participants of formData.controls; let i = index"
          >
            <td [formGroupName]="i">
              <input type="text" class="ir-form-set" formControlName="name" />
              <validation-message
                [validationControl]="participantsForm.controls.participants.controls[i].controls.name"
                [validationName]="'required'"
                [errorMessage]="'common.required' | translate"
              ></validation-message>
            </td>
            <td [formGroupName]="i">
              <input type="text" class="ir-form-set" formControlName="function" />
              <validation-message
                [validationControl]="participantsForm.controls.participants.controls[i].controls.function"
                [validationName]="'required'"
                [errorMessage]="'common.required' | translate"
              ></validation-message>
            </td>
            <td class="th-plugin-line--remove">
              <i class="material-icons" (click)="remove(i)">remove_circle</i>
            </td>
          </tr>
          <tr class="th-plugin-line--add">
            <td colspan="8">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="!participantsForm.valid"
            *ngIf="!processing"
          >
            <span>{{ 'common.add' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
